var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-collapse",
    {
      attrs: { accordion: true },
      model: {
        value: _vm.active,
        callback: function($$v) {
          _vm.active = $$v
        },
        expression: "active"
      }
    },
    [
      _c(
        "el-collapse-item",
        { attrs: { title: "Comments (optional)", name: "comment" } },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              rows: 4,
              placeholder: "Write extra comments",
              disabled: !_vm.answerExists
            },
            model: {
              value: _vm.comment,
              callback: function($$v) {
                _vm.comment = $$v
              },
              expression: "comment"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }